import React from "react";
import {Container, Row, Col} from "react-bootstrap";

function TableIcon({direction}) {
  return (
    <>
        <i className={`${(direction === "asc") ? "fa fa-arrow-up" : "fa fa-arrow-down"}` + " mx-2 fs-5"}>

        </i>
    </>
  );
}

export default TableIcon;
